import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Severity } from "../../../constants";
import * as styles from "./styles_vanilla.css";

interface SeverityChipProps {
  severity: Severity;
  count?: number;
  text?: string;
}

export const SeverityChip: React.FC<SeverityChipProps> = ({ severity, count, text }) => {
  const getChipStyles = () => {
    return severity === Severity.ERROR ? styles.errorChip : styles.warningChip;
  };

  const getTextStyles = () => {
    return severity === Severity.ERROR ? styles.errorText : styles.warningText;
  };

  const getDisplayText = () => {
    if (text) return text;
    if (count !== undefined) {
      return `${count} ${severity}${count !== 1 ? "s" : ""}`;
    }
    return severity;
  };

  return (
    <Flex alignItems="center" justifyContent="center" className={getChipStyles()}>
      <Text variant="strong-sm" className={getTextStyles()}>
        {getDisplayText()}
      </Text>
    </Flex>
  );
};
